import React from 'react';
import sBut from "../../assets/styles/buttons.module.css";
interface LogoutButtonProps {
    logoutHandler?: () => void;
}

export const LogoutButton: React.FC<LogoutButtonProps> = ({logoutHandler}) => {

    return (
        <button onClick={logoutHandler} className={sBut.logoutButton}>
            Выход
        </button>
    )
};